import type { GetSessionsAssetsResponse } from '@carboncopyco/data';
import type { ReactElement } from 'react';
import { useDashboardProps } from '../DashboardContext';
import { RowWrapper } from '../RowWrapper';
import { useAssetStatus } from '../hooks';

type DemoRowWrapperProps = {
  children: ReactElement;
  item: GetSessionsAssetsResponse;
};

export const DemoRowWrapper = ({ children, item }: DemoRowWrapperProps) => {
  const { goToDemo, goToPlaybook } = useDashboardProps();
  const getIsAssetWorkspaceExists = useAssetStatus();
  const hasMoved = !getIsAssetWorkspaceExists(item.asset);

  const onRowClick = () => {
    if (hasMoved || item?.asset?.isDeleted) {
      return;
    }
    const navFunction = {
      playbook: goToPlaybook,
      demo: goToDemo,
    };
    navFunction[item.asset.assetType](
      item.asset.assetId,
      item.asset.workspaceId
    );
  };

  return (
    <RowWrapper
      onRowClick={onRowClick}
      size="lg"
      separator
    >
      {children}
    </RowWrapper>
  );
};
